@if (rows.length > 0) {
  <div class="accordion-content-wrapper">
    <p dsContent [contentPath]="'billing.paymentScheduleTxt'"></p>
    <br />
    <p dsContent [contentPath]="'billing.paymentScheduleTxt2'" applicationDependentCopy="true"></p>
    <ngx-datatable
      class="none md-block"
      [ngClass]="cssClasses"
      [cssClasses]="{
        pagerLeftArrow: 'icon-chevron-left',
        pagerRightArrow: 'icon-chevron-right',
        pagerPrevious: 'icon-arrow-left-double',
        pagerNext: 'icon-arrow-right-double'
      }"
      [rows]="rows"
      [columns]="columns"
      [columnMode]="'force'"
      [headerHeight]="60"
      [rowHeight]="'auto'"
      [scrollbarH]="true"
      [limit]="10"
    >
    </ngx-datatable>
    <ds-table class="block md-none" [rows]="rows" [columns]="columns" [headerHeight]="60">
    </ds-table>
  </div>
}
@if (rows.length === 0) {
  <div class="accordion-content-wrapper">
    <p dsContent [contentPath]="'billing.noSchedulePayments'"></p>
    <br />
    <ul style="list-style-type: disc">
      <li><p dsContent [contentPath]="'billing.noSchedulePaymentsReasons'"></p></li>
      <p dsContent [contentPath]="'billing.reviewFuturePayments'"></p>
    </ul>
  </div>
}
<ng-template #headerCellTpl let-column="column">
  <div class="header-cell table-header-cell-wrapper header">
    <span
      [ngClass]="{
        'none lg-block': column?.name && column?.shortName,
        block: column?.name && !column?.shortName
      }"
      >{{ column?.name }}</span
    >
    @if (!!column?.shortName) {
      <span class="block lg-none">{{ column?.shortName }}</span>
    }
  </div>
</ng-template>

<ng-template #dateCellTmpl let-row="row">
  <div class="date-cell table-body-cell-label-content ds-table-body-cell-header-wrapper">
    <span class="none md-block ds-table-body-cell-data">{{
      row.paymentDueDate | date: 'MMMM d, y'
    }}</span>

    <span class="ds-table-body-cell-header">
      <h3 class="margin-0" title="{{ row.paymentDueDate }}">
        {{ row.paymentDueDate | date: 'MMMM d, y' }}
      </h3>
    </span>
  </div>
</ng-template>
<ng-template #amtCellTpl let-row="row">
  <div class="date-cell table-body-cell-label-content ds-table-body-cell-header-wrapper">
    <div class="Table-row Table-header">
      <span class="none md-block ds-table-body-cell-data" data-cy="amountDue">{{
        row.minimumAmountDue | currencyUSD
      }}</span>
    </div>
  </div>
</ng-template>
